import React from "react";
import { Link } from "react-router-dom";

function Shubhbanner() {
  return (
    <section className="container my-5">
      <div className="row justify-content-center">
        <div className="col-12 col-md-12 col-lg-10">
          <div className="rounded-3 p-3 p-md-4 p-lg-5 d-flex flex-column flex-md-row align-items-center justify-content-between gap-3 bg-gradient-purple">
            <div className="text-white text-center text-md-start text-banner">
              <h3 className="fw-semibold fs-5 fs-sm-5 fs-md-5 fs-lg-4 mb-2">
                Pre–Approved loan now available for existing&nbsp;
                <br className="d-none d-md-block" />
                customers. Kindly fill in the details below.
              </h3>
            </div>

            <div className="d-flex justify-content-center justify-content-md-end">
              <Link
                to="/preapproveLoan"
                className="btn btn-primary fw-semibold d-flex align-items-center px-3 px-md-2 py-2 rounded-4"
              >
                Apply Now
                <i className="fas fa-arrow-right ms-2 ms-md-3"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Shubhbanner;
